module.exports = __webpack_public_path__ + "img/alert-error.571d41f2.svg";